export default __webpack_public_path__ + "static/img/clouds.da690d7.webp";